<template>
    <div>
        
        <!-- Filter Start -->
        <div class="innerBox mb-4">
            <div class="row">
                <div class="col-md-2">
                    <a 
                        class="navbar-brand ml-3"
                        style="font: normal normal normal 16px/25px Poppins;">Check TO</a>
                </div>
                <div class="col-md-8">
                    <input
                        class="form-control filterInput"
                        type="search"
                        placeholder="Masukkan Nomor TO/NOPOL"
                        aria-label="Search"
                        style="display: flex; font: normal normal normal 16px/25px Poppins;"
                        v-model="filter.search"
                    >
                </div>
                <div class="col-md-2 text-right" style="display: flex; justify-content: flex-end">
                    <button
                        class="btn"
                        type="button"
                        style="background-color: #1B698E; color: white; padding: 0 50px; height: 100%; font-weight: bold; display: flex; align-items: center; font: normal normal 600 14px/21px Poppins;"
                        @click="vue_universal_table.update++"
                    >CARI</button>
                </div>
            </div>
        </div>
        <!-- Filter End -->

        <!-- Body Start -->
        <div class="innerBox list-card">
            <!-- Title & Option Buttons Start -->
            <div class="list-toolbar">
                <h3 class="list-title">Pengecekan Surat Jalan</h3>
                <div class="list-toolbar-actions">
                    <div class="date-filter">
                        <span class="date-filter-label">Filter tanggal</span>
                        <div class="date-filter-input">
                            <flat-pickr
                                :config="rangePickr"
                                placeholder="Select Date"
                                v-model="selected.date"
                            ></flat-pickr>
                        </div>
                    </div>
                    <div class="list-actions">
                        <button
                            v-if="isAccountingUser"
                            class="btn list-action-button list-download-button"
                            type="button"
                            @click="downloadExcel"
                            :disabled="isDownloading"
                        >
                            {{ isDownloading ? 'Downloading...' : 'Download' }}
                        </button>
                        <button
                            class="btn list-action-button list-confirm-button"
                            :class="{ 'd-none': hideButton }"
                            type="button"
                            @click="showModalMultiple"
                        >
                            Konfirmasi
                        </button>
                    </div>
                </div>
            </div>
            <!-- Title & Option Buttons End -->
            
            <!-- Table Start -->
            <pengecekan-grouped-table
                ref="groupedTable"
                :filter="filter"
                :update="vue_universal_table.update"
                @view-details="openGroupedDetails"
                @selection-change="handleSelectionChange"
            ></pengecekan-grouped-table>
            <!-- Table End -->

        </div>
        <!-- Body End -->

        <!-- Modal Start -->
        <pengecekan-details-multiple
            v-if="modal.detailsMultiple"
            :data="modal.data"
            @closeModal="modal.detailsMultiple = false"
            @refreshTable="refreshAfterMultipleAction"
        ></pengecekan-details-multiple>
        <!-- Modal End -->

    </div>
</template>

<script>
    import moment from 'moment'
    import debounce from 'debounce';
    import qs from 'qs';
    import pengecekanDetailsMultiple from './children/PengecekanDetailsMultiple'
    import pengecekanGroupedTable from './children/PengecekanGroupedTable'
// import { threadId } from 'worker_threads';

    export default {
        metaInfo : {
            title : 'Pengecekan TO'
        },
        data () {

            let startDate = moment().subtract(7, 'days').format("YYYY-MM-DD");
            let currentDate = moment().format("YYYY-MM-DD");

            return {
                hideButton: true,
                isDownloading: false,
                modal: {
                    detailsMultiple: false,
                    data : {
                        no_to : null,
                        id : null,
                        kode_rute : null,
                    },
                },
                rangePickr: {
                    mode: 'range',
                    dateFormat: "Y-m-d",
                    altInput: true,
                    altFormat: "d-m-Y",
                            altInputClass: 'form-control input pengecekan-date-input'
                },
                selected : {
                    dateButtonsIndex : 2,
                    date : `${startDate} to ${currentDate}`
                },
                filter : {
                    start : startDate,
                    end : currentDate,
                    search : null,
                },
                vue_universal_table : {
                    fields : [
                        {title:"NO TO", variable:"no_to"},
                        {title:"SJ TOTAL", variable:"total_sj"},
                        {title:"Koli Total : Jumlah dus", variable:"total_coly"},
                        {title:"TANGGAL SJ", variable:"tanggal_sj"},
                        {title:"NOPOL", variable:"nopol"},
                        {title:"DRIVER", variable:"driver"},
                        {title:"URUTAN TRUK", variable:"no_antrian"},
                        {title:"Check Status SJ & Koli", variable:"status_sj2", class:"green", disable_sort: true},
                        {title:"Check Status Rute", variable:"status_rute2", disable_sort: true},
                    ],
                    buttons: [
                        {
                            title: 'viewDetails',
                            class: 'fas fa-pen btn-outline-primary',
                            style: 'background-color: #1B698E; color: white;',
                            condition: "data.id != 'Belum ada Input'"
                        },
                    ],
                    filter : {},
                    update : 0,
                    process_data : `
                        for (var i in data) {
                            data[i].status_sj2 = data[i].status_sj == 1 ? "✔" : "❌";
                            data[i].status_rute2 = data[i].status_rute == 1 ? "✔" : "❌";
                            data[i].driver = data[i].driver.replace(/[^a-zA-Z0-9]/g, " ");
                        }
                    `,
                    data: []
                },
                selectedRowIds: [],
                selectedFullData: [],
                persistentSelectedData: []
            }
        },
        components : {
            pengecekanDetailsMultiple,
            pengecekanGroupedTable,
        },
        computed: {
            isAccountingUser() {
                const user = this.$store.getters.currentUser;
                return user && user.role === 'ACCOUNTING';
            },
        },
        mounted () {

        },
        watch : {
            'selected.date' () {
                let split = this.selected.date.split(" to ");
                this.filter.start = split[0];
                this.filter.end = split.length > 1 ? split[1] : split[0];

                //Check End
                if (this.filter.end != moment().format('YYYY-MM-DD')){
                    this.selected.dateButtonsIndex = -1;
                //Check Start
                } else if (this.options.dateButtons.map(x=>x.start).indexOf(this.rangePickr.start) == -1) {
                    this.selected.dateButtonsIndex = -1;
                //Found Match
                } else {
                    this.selected.dateButtonsIndex = this.options.dateButtons.map(x=>x.start).indexOf(this.rangePickr.start);
                }

                this.vue_universal_table.update++;
                this.modal.edit = false
                this.modal.new = false
            },
            'selected.dateButtonsIndex' () {
                // this.filter.filter = this.selected.dateButtonsIndex != -1 ? this.options.dateButtons[this.selected.dateButtonsIndex].filter : 'CUSTOM'
            },
            'filter' : {
                deep : true,
                handler : 'emitFilter'
            },
            'selectedFullData'() {
                if (this.selectedFullData.length > 0) {
                    this.hideButton = false;
                } else {
                    this.hideButton = true;
                }
            }
        },
        methods : {
            openGroupedDetails (group) {
                this.modal.data = {
                    selectedItems: group.children.map(child => ({
                        ...child,
                        nopol: group.nopol,
                        driver: group.driver,
                        tanggal_sj: group.tanggal_sj,
                        group_key: group.group_key
                    }))
                };
                this.modal.detailsMultiple = true;
            },
            showModalMultiple() {
                // Pass selected items to modal
                this.modal.data = {
                    selectedItems: this.selectedFullData
                };
                this.modal.detailsMultiple = true;
            },
            selectDateButton (i) {
                this.selected.date = `${this.options.dateButtons[i].start} to ${this.options.dateButtons[i].end}`
                this.selected.dateButtonsIndex = i;
            },
            debouncelessEmitFilter () {
                this.$emit('filterChange', this.vue_universal_table.update++);
            },
            downloadExcel() {
                if (this.filter.search === '') delete this.filter.search;

                this.isDownloading = true;
                this.$http.get(`/api/validation/cek-to/export-excel?${qs.stringify(this.filter, { skipNulls: true, arrayFormat: 'comma' })}`, {
                    responseType: 'blob',
                    headers: {
                        'Cache-Control': 'no-cache',
                        Pragma: 'no-cache'
                    }
                })
                    .then((response) => {
                        const href = URL.createObjectURL(response.data);
                        const link = document.createElement('a');
                        link.href = href;
                        link.setAttribute('download', `cek-to-${moment().format('YYYYMMDDHHmmss')}.xlsx`);
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        URL.revokeObjectURL(href);
                    })
                    .catch((err) => {
                        console.log(err);
                    })
                    .finally(() => {
                        this.isDownloading = false;
                    });
            },
            emitFilter: debounce(function () {
                this.$emit('filterChange', this.vue_universal_table.update++);
            }, 1500),
            handleSelectionChange(selectedRowIds) {
                this.selectedFullData = selectedRowIds;
                this.selectedRowIds = selectedRowIds.map(item => `${item.nopol}|${item.no_to}`);
                this.persistentSelectedData = [...selectedRowIds];
            },
            refreshAfterMultipleAction() {
                this.selectedRowIds = [];
                this.selectedFullData = [];
                this.persistentSelectedData = [];

                if (this.$refs.groupedTable) this.$refs.groupedTable.clearSelection();

                this.vue_universal_table.update++;
            }
        }
    }
</script>

<style>
    .green {
        color: green;
    }
</style>

<style scoped>
    .innerBox {
        background-color: white;
        border-radius: 8px;
        box-shadow: 0px 3px 10px #0000000F;
        padding: 20px;

    }

    .list-card {
        padding: 30px 34px 0;
    }

    .list-toolbar {
        display: grid;
        grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);
        align-items: center;
        gap: 24px;
        min-height: 76px;
        padding-bottom: 28px;
        border-bottom: 1px solid #f0f0f0;
    }

    .list-title {
        grid-column: 2;
        margin: 0;
        color: #343434;
        font: normal normal normal 16px/25px Poppins;
        white-space: nowrap;
    }

    .list-toolbar-actions {
        grid-column: 3;
        justify-self: end;
        display: flex;
        align-items: center;
        gap: 15px;
        min-width: 0;
    }

    .date-filter,
    .list-actions {
        display: flex;
        align-items: center;
        gap: 12px;
        white-space: nowrap;
    }

    .date-filter-label {
        color: #343434;
        font: normal normal normal 12px/18px Poppins;
    }

    .date-filter-input {
        width: 220px;
        flex-shrink: 0;
    }

    .list-action-button {
        padding: 8px 18px;
        white-space: nowrap;
        font: normal normal normal 14px/21px Poppins;
    }

    .list-download-button {
        background-color: #c9ecfb;
        color: #333333;
    }

    .list-confirm-button {
        background-color: #f36f21;
        color: white;
        font-weight: bold;
    }

    .chart {
        background-color: white;
        border-radius: 8px;
        box-shadow: 0px 3px 10px #0000000F;
        padding: 20px;
        align-items: center;
    }

    .elegant--sub-title {
        font-size: 18px;
        font-weight: 500;
        color: #9F9F9F;
    }

    .tableTitle {
        text-align: center;
    }

    /* .center {
        padding: 50px 20px;
        display: flexbox;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    } */

    .stats--icon {
        display:flex; 
        align-items:center; 
        justify-content:center;
        text-align: center;
    }

    .table td, .table th{
        text-align: center;
    }

    @media (max-width: 1200px) {
        .list-toolbar {
            grid-template-columns: 1fr;
            justify-items: center;
        }

        .list-title,
        .list-toolbar-actions {
            grid-column: 1;
        }

        .list-toolbar-actions {
            justify-self: center;
            flex-wrap: wrap;
            justify-content: center;
        }
    }
</style>

<style>
    .pengecekan-date-input {
        width: 220px !important;
        height: 42px !important;
        padding: 8px 14px !important;
        border: 0 !important;
        border-radius: 10px !important;
        background-color: #c9ecfb !important;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05) !important;
        color: #343434 !important;
        text-align: center;
        font: normal normal normal 12px/18px Poppins !important;
    }
</style>
